import _ from 'lodash';
import update from 'immutability-helper';
import I18n from '../../config/i18n';
import { getCurrentPath } from '../common/utils';
import enums from '../common/utils/enums';
import * as routePath from '../common/utils/routePath';
import * as cookie from '../common/utils/cookie';
import { formatErrorMessage } from '../common/utils/error';
import {
  initializeUserAccount,
  loadAccountData,
  loadUserInfo,
} from './account';
import { receiveApprovals } from './approvals';
import { loadTimezones } from './timezones';
import { loadCountries } from './countries';
import { receiveInventory } from './inventory';
import { loadWorkOrdersCount } from './workOrders';

const initialState = {
  initialized: false,
  overlay: null,
  isBusy: false,
  error: null,
};

const INITIALIZE = 'app/INITIALIZE';
const OVERLAY = 'app/OVERLAY';
const SHOW_BUSY = 'app/SHOW_BUSY';
const SHOW_APP_ERROR = 'app/SHOW_APP_ERROR';

function handleUserUnAuthorizationStatus(error) {
  if (error.data && error.data.noAccess) {
    cookie.set(
      cookie.KEY_USER_AUTHORIZATION_STATUS,
      cookie.USER_AUTHORIZATION_STATUS.NO_ACCESS,
    );
  } else {
    cookie.set(
      cookie.KEY_USER_AUTHORIZATION_STATUS,
      cookie.USER_AUTHORIZATION_STATUS.UNAUTHORIZED,
    );
  }
}

export function loadApp() {
  return (dispatch) => {
    return dispatch(loadUserInfo())
      .then((res) => {
        cookie.set(
          cookie.KEY_USER_AUTHORIZATION_STATUS,
          cookie.USER_AUTHORIZATION_STATUS.AUTHORIZED,
        );
        const user = _.omit(res.data, 'approvals');
        dispatch(initializeUserAccount(user));
        dispatch(
          receiveApprovals(res.data.approvals ? res.data.approvals : {}),
        );
        dispatch(loadAccountData());
      })
      .then(() => {
        const currentPath = getCurrentPath();
        if (
          [routePath.workOrdersRoute, routePath.workOrdersPastRoute].includes(
            currentPath,
          )
        ) {
          dispatch(loadWorkOrdersCount());
        }
        dispatch(loadTimezones());
        dispatch(loadCountries());
      })
      .then(() => dispatch(initializeApp()))
      .catch((error) => {
        dispatch(handleAppError(error, I18n.t('unexpectedError')));
        dispatch(initializeApp());
      });
  };
}

export function updateUserInfo(showAppBusyStatus = true) {
  return (dispatch) => {
    dispatch(showAppBusy(showAppBusyStatus));
    return dispatch(loadUserInfo())
      .then((res) => {
        const user = _.omit(res.data, 'approvals');
        const partner = user && user.partner;
        dispatch(receiveInventory(partner));
        dispatch(showAppBusy(false));
      })
      .catch((error) => {
        dispatch(showAppBusy(false));
        dispatch(handleAppError(error, I18n.t('unexpectedError')));
      });
  };
}

export function showAppBusy(show) {
  return { type: SHOW_BUSY, payload: show };
}

export function showAppError(errorInfo) {
  return { type: SHOW_APP_ERROR, payload: errorInfo };
}

export function handleAppError(error, title) {
  return (dispatch) => {
    const _error = error.response;

    if (_error && _error.status === enums.HTTP_STATUS_CODES.UNAUTHORIZED) {
      handleUserUnAuthorizationStatus(_error, dispatch);
    } else {
      if (_error && _error.status === enums.HTTP_STATUS_CODES.FORBIDDEN) {
        cookie.set(
          cookie.KEY_USER_AUTHORIZATION_STATUS,
          cookie.USER_AUTHORIZATION_STATUS.UNAUTHORIZED,
        );
      }
      if (_error && _error.status === enums.HTTP_STATUS_CODES.NOT_FOUND) {
        cookie.set(
          cookie.KEY_USER_AUTHORIZATION_STATUS,
          cookie.USER_AUTHORIZATION_STATUS.NOT_FOUND,
        );
      }
      const errorInfo = {
        title: title,
        message: formatErrorMessage(_error, I18n.t('unexpectedError')),
      };

      dispatch(showAppError(errorInfo));
    }
  };
}

export function initializeApp() {
  return { type: INITIALIZE };
}

export default function reducer(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case INITIALIZE:
      return update(state, { initialized: { $set: true } });

    case OVERLAY:
      return update(state, { overlay: { $set: payload } });

    case SHOW_BUSY:
      return update(state, { isBusy: { $set: payload } });

    case SHOW_APP_ERROR:
      return update(state, { error: { $set: payload } });

    default:
      return state;
  }
}
